module.exports = __webpack_public_path__ + "img/abdomen.3325a843.svg";